<template>
  <content-card :title="$t('charge-location-list.title')"
                icon="location_on">
    <template v-slot:titleBar>
      <v-icon v-if="!loading && chargeLocations.length > 0" class="add_location_icon material-icons-outlined"
              color="primary" @click="newLocation()">
        add_circle
      </v-icon>
    </template>
    <template v-slot:content>
      <v-skeleton-loader v-if="loading" type="article"
                         height="200"></v-skeleton-loader>
      <v-list v-if="!loading">
        <div v-if="chargeLocations.length > 0">
          <v-list-item class="mx-2" v-for="(location, i) in chargeLocations" :key="i">
            <v-list-item-icon>
              <v-icon color="primary">location_on</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ location.name }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="primary" @click.stop="editLocation(location)">edit</v-icon>
            </v-list-item-action>
          </v-list-item>
        </div>
        <v-list-item class="mx-2" v-else @click="newLocation">
          <v-list-item-content>
            <v-list-item-title>{{ $t('charge-location-list.create-first-location') }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon color="primary">add_circle</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </template>
  </content-card>
</template>

<script>
import ContentCard from "@/templates/components/ContentCard.vue";

export default {
  name: "ChargeLocationsList",
  components: {ContentCard},
  props: ['vehicleId'],
  data() {
    return {
      chargeLocations: [],
      loading: true
    };
  },
  methods: {
    fetchChargeLocations() {
      this.loading = true;
      this.$rhRequest.sendGet(
          {
            endpoint: "enode/get-user-locations"
          },
          (response) => {
            this.chargeLocations = response?.data?.data;
            this.loading = false;
          },
          (error) => {
            console.error(error);
            this.loading = false;
          }
      )
    },
    editLocation(location) {
      this.$root.bisadialog.toggle("smartChargingOnboarding", false);
      this.$root.bisadialog.toggle("location", true, {location, vehicleId: this.vehicleId  });
      this.$root.bisadialog.callDialogInit("location");
    },
    newLocation() {
      this.$root.bisadialog.toggle("smartChargingOnboarding", false);
      this.$root.bisadialog.toggle("location", true, {vehicleId: this.vehicleId});
    }
  },
  mounted() {
    this.fetchChargeLocations();
  }
}
</script>

<style>
@import "@/styles/charge-location-list.scss";
</style>